export default __webpack_public_path__ + "static/media/LNCT-college.08cb9ed1.jpg";